module.exports = __webpack_public_path__ + "static/media/ZAPTalent-Logotipo-Original.c443fd62.svg";